import axios from 'axios';
import { toast } from './toast';
import i18n from '../i18n';
import { useUiStore } from '../store/uiStore';
import { useAuthStore } from '../store/authStore';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/tools/api/public/api/v1',
  // Pojistka proti nekonečnému „točení" — pomalý/mrtvý cizí web v nástroji
  // jinak drží spinner navždy. Po vypršení přijde chyba, kterou UI zobrazí.
  timeout: 120000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Attach JWT token + aktuální jazyk (pro lokalizované hlášky z backendu) k requestům
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.headers['X-Lang'] = (i18n.language || 'cs').slice(0, 2);
  return config;
});

// Handle 401 responses (expired session) — but NOT auth endpoints,
// where a 401 just means wrong credentials and must surface in the form.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url ?? '';
    const isAuthRequest = url.includes('/auth/');
    if (error.response?.status === 401 && !isAuthRequest) {
      // Relace vypršela — vyčisti a ukaž přátelskou obrazovku (ne tvrdý redirect).
      const wasLoggedIn = !!localStorage.getItem('token');
      useAuthStore.getState().logout();
      if (wasLoggedIn) {
        useUiStore.getState().endSession('expired');
      } else {
        useUiStore.getState().openAuthModal('login');
      }
    } else if (error.response?.status === 403 && error.response.data?.email_unverified) {
      // Akce blokovaná neověřeným e-mailem
      toast.error(error.response.data?.message || i18n.t('verify.required', { defaultValue: 'Nejdřív ověřte svůj e-mail.' }));
    } else if (!error.response) {
      // Síťová chyba / timeout — request vůbec nedorazil
      toast.error(i18n.t('common.error_network', { defaultValue: 'Připojení selhalo. Zkuste to prosím znovu.' }));
    } else if (error.response.status >= 500) {
      // Chyba serveru — ať to uživatel nevidí jen jako tiché selhání
      toast.error(error.response.data?.message || i18n.t('common.error_server', { defaultValue: 'Chyba serveru. Zkuste to prosím znovu.' }));
    }
    return Promise.reject(error);
  }
);

export default api;
